import { gql } from '__generated__';

export default gql(`
  query GetHomePage($countries: [String!]) {
    session {
      id
      user {
        id
        first_name
        full_name
        email
        locale
        sport_type
        registration_summaries(upcoming: true) {
          id
          view_token
          registrations_count
          participant {
            id
          }
          event {
            id
            title
            start_date
            end_date
            project {
              id
              organisation_name
              timezone
            }
            logo {
              id
              url
            }
          }
        }
      }
    }
    upcomingEvents: publicEvents(countries: $countries, per_page: 6) {
      current_page
      last_page
      per_page
      total
      data {
        ...CalenderEventFields
      }
    }
    trendingEvents: publicEvents(sort: "trending", per_page: 6) {
      current_page
      last_page
      per_page
      total
      data {
        ...CalenderEventFields
      }
    }
  }
`);
